<div class="card-container card rounded-lg py-4 px-5">
  <div class="message-section">
    <span class="user-name">Hi, {{userName}}</span>
    <h2 class="title">{{message}}</h2>
  </div>
  <div class="image-section">
    <div class="person-with-line">
        <img style="width: 100%;" src="../../../assets/images/empty-state/person-with-line.svg">
    </div>
    <!-- <button class="btn btn-primary buy-hardware">
      {{buttonText}}
      <i class="right-arrow-icon fas fa-arrow-right"></i>
    </button> -->
  </div>
</div>
